import React from 'react';
import PropTypes from 'prop-types';

const OrderSummaryComponent = ({ order, giftDiscount, currentTotal }) => {
  // Get values from order object with proper number conversion
  const originalTotal = Number(order.originalTotal) || 0;
  const productDiscount = Number(order.totalDiscount) || 0;
  let shipping = Number(order.shippingCharge) || 0;

  // If shipping is 0 but totalAmount is greater than originalTotal - discount
  // then shipping is already included
  const subtotalBeforeShipping = originalTotal - productDiscount;
  const backendTotal = Number(order.totalAmount) || 0;

  // Check if shipping is already included in backend total
  const isShippingIncluded = backendTotal > subtotalBeforeShipping;

  // If shipping not included in backend total, calculate it
  if (!isShippingIncluded && shipping === 0) {
    shipping = subtotalBeforeShipping > 500 ? 0 : 60;
  }

  // Calculate correctly
  const afterProductDiscount = subtotalBeforeShipping;
  const afterShipping = isShippingIncluded
    ? backendTotal
    : afterProductDiscount + shipping;
  const afterGiftDiscount = Math.max(
    afterShipping - (Number(giftDiscount) || 0),
    0,
  );

  return (
    <div className="order-summary">
      <div className="summary-row">
        <span>MRP (incl. of all taxes)</span>
        <span>₹{originalTotal.toFixed(2)}</span>
      </div>
      <div className="summary-row">
        <span>Items Total</span>
        <span>{order.items?.length || 0} items</span>
      </div>
      <div className="summary-row discount">
        <span>Product Discounts</span>
        <span>-₹{productDiscount.toFixed(2)}</span>
      </div>
      <div className="summary-row">
        <span>Subtotal</span>
        <span>₹{afterProductDiscount.toFixed(2)}</span>
      </div>
      <div className="summary-row">
        <span>Shipping & Handling</span>
        <span>₹{shipping.toFixed(2)}</span>
      </div>
      {giftDiscount > 0 && (
        <div className="summary-row discount">
          <span>Gift Card Discount</span>
          <span>-₹{Number(giftDiscount).toFixed(2)}</span>
        </div>
      )}
      <hr />
      <div className="total-row">
        <span>Total Amount</span>
        <span style={{ fontWeight: 800 }}>
          ₹{afterGiftDiscount.toFixed(2)}
        </span>
      </div>
      <div className="summary-fees">
        <i className="fas fa-info-circle"></i> Inclusive of all taxes
      </div>
      <div className="instant-offer">
        <div>
          <i className="fas fa-bolt" style={{ color: "#f9a825" }}></i>
          <strong>5% instant discount</strong>
          <br />
          <span style={{ fontSize: "0.7rem" }}>on HDFC Bank Credit Card</span>
        </div>
        <div className="offer-tag">+3 offers</div>
      </div>
    </div>
  );
};

// Add PropTypes validation
OrderSummaryComponent.propTypes = {
  order: PropTypes.shape({
    originalTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalDiscount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shippingCharge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    items: PropTypes.array,
  }).isRequired,
  giftDiscount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

OrderSummaryComponent.defaultProps = {
  giftDiscount: 0,
  currentTotal: 0,
};

export default OrderSummaryComponent;